import React, { useEffect } from 'react';
import Layout from '@/common/Layout';
// import FeebBack from './components/FeebBack';
import Cookpage from './components/Cookie.js';

const index = () => {
  useEffect(() => {
    document.title = 'Cookie Policy - Website Usage Information';
  }, []);

  return (
    <>
      <Layout
        // sider={true}
        hideHeader={true}
      >
        {/* <FeebBack /> */}
        <Cookpage />
      </Layout>
    </>
  );
};

export default index;
